import { Component, OnInit } from '@angular/core'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { TabsComponent } from '@components/tabs/tabs.component'
import { Tab } from '../../interfaces/tab.interface'
import { NgForOf, NgIf } from '@angular/common'
import { CAcademyFormation } from '../../interfaces/c-academy-formation'
import { CAcademyCardComponent } from '@components/c-academy-card/c-academy-card.component'
import { PaginationComponent } from '@components/pagination/pagination.component'
import { CAcademyListComponent } from '@components/c-academy-list/c-academy-list.component'
import { ApiService } from '../../services/api.service'
import { LoadingService } from '../../services/loading.service'

@Component({
  selector: 'app-c-academy',
  standalone: true,
    imports: [
        TranslateModule,
        TabsComponent,
        NgForOf,
        CAcademyCardComponent,
        PaginationComponent,
        CAcademyListComponent,
        NgIf
    ],
  templateUrl: './c-academy.component.html',
  styleUrl: './c-academy.component.scss'
})
export class CAcademyComponent implements OnInit{

    tabs: Tab[] = [
        {
            value: 'ongoing',
            label: 'ongoing',
        },
        {
            value: 'completed',
            label: 'completedF',
        },
        {
            value: 'favourites',
            label: 'favourites',
        }
    ]


    activeTab: string = 'ongoing';
    yourFormationsCurrentPage: number = 0;
    yourFormationsTotalPages: number = 1;
    elementsPerPage: number = 2;

    currentPageFormations: CAcademyFormation[];

    yourCurrentFormations: CAcademyFormation[] = [];
    yourCompletedFormations: CAcademyFormation[] = [];
    yourFavouriteFormations: CAcademyFormation[] = [];

    availableFormations: CAcademyFormation[] = [];

    constructor(private translate: TranslateService, private api: ApiService, private loadingService: LoadingService) {
        this.translate.get(['ongoing', 'completedF', 'favourites',
            'cacademy.application.kitchen_countertop',
            'cacademy.application.facade',
            'cacademy.application.sink',
            'cacademy.application.bathroom_sink_and_countertop',
            'cacademy.application.shower_tray',
            'cacademy.application.flooring',
            'cacademy.application.tabletop',
            'cacademy.application.furniture'
        ])
    }

    ngOnInit() {
        this.loadingService.show()
        this.api.getAvailableFormations().subscribe(availableFormations => {
            this.availableFormations = availableFormations;
            this.setupFormationsData();

            this.loadingService.hide()
        })
    }

    setupFormationsData(){
        this.yourCurrentFormations = this.availableFormations.filter(form => form.isStarted && !form.completedAt);
        this.yourCompletedFormations = this.availableFormations.filter(form => form.completedAt)
        this.yourFavouriteFormations = this.availableFormations.filter(form => form.isFavourite)

        this.tabs = [
            {
                value: 'ongoing',
                label: 'ongoing',
                qty: this.yourCurrentFormations.length,
                gtmLabel: 'your-trainings_filter_on-going'
            },
            {
                value: 'completed',
                label: 'completedF',
                qty: this.yourCompletedFormations.length,
                gtmLabel: 'your-trainings_filter_completed'
            },
            {
                value: 'favourites',
                label: 'favourites',
                qty: this.yourFavouriteFormations.length,
                gtmLabel: 'your-trainings_filter_favourites'
            }
        ]

        this.setupCurrentPageFormations()
    }

    setupCurrentPageFormations(){
        switch (this.activeTab) {
            case 'ongoing':
                this.currentPageFormations = this.yourCurrentFormations;
                break;
            case 'completed':
                this.currentPageFormations = this.yourCompletedFormations;
                break;
            case 'favourites':
                this.currentPageFormations = this.yourFavouriteFormations;
                break;
        }
        this.yourFormationsTotalPages = Math.ceil(this.currentPageFormations.length / this.elementsPerPage);
        this.currentPageFormations = this.currentPageFormations.slice(
            this.yourFormationsCurrentPage * this.elementsPerPage,
            (this.yourFormationsCurrentPage + 1) * this.elementsPerPage
        );
    }

    onTabChange(tab: string) {
        if(this.activeTab === tab) return;
        this.yourFormationsCurrentPage = 0
        this.activeTab = tab;
        this.setupCurrentPageFormations()
    }

    onYourFormationsPageChange(page: number) {
        this.yourFormationsCurrentPage = page
        this.setupCurrentPageFormations();
    }

    onFormationUpdate() {
        this.setupFormationsData()
    }
}
